module.exports = __webpack_public_path__ + "static/media/stop.1d82bd2f.svg";